const SDK_VERSION = '8.24.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
